import { NylasGetMessageRequestContent, NylasGetMessageResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to get a specific message by ID
 * @param request Message retrieval parameters (connectionId, messageId)
 * @returns Promise with full message details including body
 */
export const getIntegrationMessageApi = async (request: NylasGetMessageRequestContent): Promise<NylasGetMessageResponseContent> => {
  const apiRequest = createApiRequest<NylasGetMessageResponseContent>('post', '/integrations/nylas/messages/get');
  return apiRequest(request);
};
